import React, {useState} from 'react';
import PropTypes from 'prop-types';

const TextInput = (props) => {

    return (
        <div className={`textInput ${props.classes ? props.classes : ''}`}>
            <span className="textInput__title">{props.title}</span>
            <input type={props.type} className={`textInput__select ${props.hasError ? "error" : "normal"}`} onChange={props.onChange} value={props.value} placeholder={props.placeholder}/>
            <span className="textInput__description">{props.description}</span>
        </div>
    )
}

TextInput.defaultProps = {
    type: 'text',
}

TextInput.propTypes = {
    type: PropTypes.oneOf(['text', 'password', 'number']),
    title: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired
}

export default TextInput;